import React from "react";
//Anmation
import { motion } from "framer-motion";
import { pageAnimation, titleAnim } from "../animation";
import styled from "styled-components";

function ContactUs() {
  return (
    <ContactStyled
      exit="exit"
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      style={{ background: "#fff" }}
    >
      <Title>
        <Hide>
          <motion.h2 variants={titleAnim}>Get in touch.</motion.h2>
        </Hide>
      </Title>
      <div>
        <Hide>
          <Soical variants={titleAnim}>
            <Circle />
            <h2>Send Us A Massege</h2>
          </Soical>
        </Hide>
        <Hide>
          <Soical variants={titleAnim}>
            <Circle />
            <h2>Send An email.</h2>
          </Soical>
        </Hide>
        <Hide>
          <Soical variants={titleAnim}>
            <Circle />
            <h2>Social Media</h2>
          </Soical>
        </Hide>
      </div>
    </ContactStyled>
  );
}

const ContactStyled = styled(motion.div)`
  padding: 5rem 10rem;
  color: #353535;
  min-height: 90vh;
  @media (max-width:1500px) {
    padding:2rem ;
    font-size:1rem;
    
  }
`;
const Title = styled.div`
  margin-bottom: 4rem;
  color: black;
  @media (max-width:1300px) {
    margin-top:5rem; 
  }
`;
const Hide = styled.div`
  overflow: hidden;
`;
const Circle = styled.div`
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  background: #353535;
`;
const Soical = styled(motion.div)`
  display: flex;
  align-items: center;
  h2 {
    margin: 2rem;
  }
`;

export default ContactUs;
